import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/promiseFrame/warn_red.png'
import _imports_1 from '../../../../../../assets/promiseFrame/fullreport_down.png'
import _imports_2 from '@/assets/promiseFrame/picture.png'
import _imports_3 from '@/assets/promiseFrame/fullreport-green.png'
import _imports_4 from '@/assets/promiseFrame/fullreport-nopart.png'
import _imports_5 from '@/assets/promiseFrame/fullreport-limited.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-1dac6d3e")

_pushScopeId("data-v-1dac6d3e")
const _hoisted_1 = { class: "ui__checkContent" }
const _hoisted_2 = {
  key: 0,
  class: "checkContent-title-left unusual"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "title-des" }
const _hoisted_5 = { class: "checkContent-title-count" }
const _hoisted_6 = {
  key: 1,
  class: "checkContent-title-left normal"
}
const _hoisted_7 = { class: "title-des" }
const _hoisted_8 = { class: "checkContent-title-count" }
const _hoisted_9 = { class: "checkContent-title-right-wrapper" }
const _hoisted_10 = {
  key: 0,
  class: "checkContent-content-wrapper"
}
const _hoisted_11 = {
  key: 0,
  class: "checkContent-item-title"
}
const _hoisted_12 = { class: "checkContent-item-name" }
const _hoisted_13 = { class: "itemname" }
const _hoisted_14 = { class: "itemicon" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "eachIcon",
  src: _imports_0
}, null, -1)
const _hoisted_16 = { class: "congvalue_container" }
const _hoisted_17 = {
  key: 1,
  class: "checkContent-item-title"
}
const _hoisted_18 = { class: "itemname" }
const _hoisted_19 = {
  key: 1,
  class: "eachIcon",
  src: _imports_3
}
const _hoisted_20 = {
  key: 2,
  class: "eachIcon",
  src: _imports_4
}
const _hoisted_21 = {
  key: 3,
  class: "eachIcon",
  src: _imports_5
}
const _hoisted_22 = { class: "checkContent-photos" }
const _hoisted_23 = { class: "photos" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "photos-look" }, "Показать всё", -1)
const _hoisted_25 = { class: "photos-count" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.checkItemList, (item) => {
      return (_openBlock(), _createBlock("div", {
        class: "checkContent",
        key: item.code
      }, [
        _createVNode("div", {
          class: ["checkContent-title", {'hideCont': item.hidden}],
          onClick: ($event: any) => (_ctx.changeItemCheckType(item))
        }, [
          (item.code === "unusual")
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _hoisted_3,
                _createVNode("span", _hoisted_4, _toDisplayString(item.title), 1),
                _createVNode("div", _hoisted_5, _toDisplayString(item.itemLists.length), 1)
              ]))
            : _createCommentVNode("", true),
          (item.code === "normal")
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getNormalTitles(item), (each) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "each-part",
                    key: each.icon
                  }, [
                    _createVNode("img", {
                      class: "checkContent-icon",
                      src: require(`@/assets/promiseFrame/${each.icon}.png`)
                    }, null, 8, ["src"]),
                    _createVNode("span", _hoisted_7, _toDisplayString(each.name), 1),
                    _createVNode("div", _hoisted_8, _toDisplayString(each.count), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_9, [
            (item.itemLists.length > 0)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  class: ["updown-icon", {'back_report': !item.hidden}],
                  src: _imports_1
                }, null, 2))
              : _createCommentVNode("", true)
          ])
        ], 10, ["onClick"]),
        ((item.itemLists.length > 0) && !item.hidden)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode("div", {
                class: ["checkContent-content", {"normal": item.code === "normal", "unusual": item.code === "unusual"}]
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.itemLists, (eachItem, eachItemIndex) => {
                  return (_openBlock(), _createBlock("div", {
                    key: eachItem.itemName,
                    class: ["checkContent-item", {'noBorder': item.code ==='normal' && item.photoList.length === 0 && eachItemIndex === item.itemLists.length - 1}]
                  }, [
                    (item.code==="unusual")
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode("div", _hoisted_12, [
                            _createVNode("span", _hoisted_13, _toDisplayString(eachItem.checkItemNameForeign), 1),
                            _createVNode("div", _hoisted_14, [
                              (eachItem.photoList.length > 0)
                                ? (_openBlock(), _createBlock("img", {
                                    key: 0,
                                    class: "picture",
                                    src: _imports_2,
                                    onClick: ($event: any) => (_ctx.goToImgView(eachItem))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              _hoisted_15
                            ])
                          ]),
                          _createVNode("div", _hoisted_16, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(eachItem.signRuleVOS, (eachDefect, index) => {
                              return (_openBlock(), _createBlock("span", {
                                key: eachDefect.defectValueCode,
                                class: {'cRed': eachDefect.redSign === 2}
                              }, _toDisplayString((index === eachItem.signRuleVOS.length - 1) ?  eachDefect.confValueForeign : (eachDefect.confValueForeign + '、')), 3))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (item.code==="normal")
                      ? (_openBlock(), _createBlock("div", _hoisted_17, [
                          _createVNode("span", _hoisted_18, _toDisplayString(eachItem.checkItemNameForeign), 1),
                          (eachItem.photoList && eachItem.photoList.length > 0)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                class: "picture",
                                src: _imports_2,
                                onClick: ($event: any) => (_ctx.goToImgView(eachItem))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (eachItem.itemDesc === "正常" || eachItem.itemDesc === "无事故痕迹" || eachItem.itemDesc === "无火烧痕迹" || eachItem.itemDesc === "无泡水痕迹")
                            ? (_openBlock(), _createBlock("img", _hoisted_19))
                            : _createCommentVNode("", true),
                          (eachItem.itemDesc === "无此部件")
                            ? (_openBlock(), _createBlock("img", _hoisted_20))
                            : _createCommentVNode("", true),
                          (eachItem.itemDesc === "受限不可检")
                            ? (_openBlock(), _createBlock("img", _hoisted_21))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128)),
                (item.photoList.length > 0)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: ["checkContent-photos-wrapper", {"normal": item.code === "normal", "unusual": item.code === "unusual"}]
                    }, [
                      _createVNode("div", _hoisted_22, [
                        _createVNode("div", _hoisted_23, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.photoList.slice(0, 4), (photo, index) => {
                            return (_openBlock(), _createBlock("img", {
                              key: index,
                              class: ["eachphoto", {'first': index === 0,'second': index === 1,'third': index === 2,'fourth': index === 3}],
                              src: photo.smallPhotoUrl
                            }, null, 10, ["src"]))
                          }), 128))
                        ]),
                        _createVNode("div", {
                          class: "photos-detail",
                          onClick: ($event: any) => (_ctx.goToImgView(item))
                        }, [
                          _hoisted_24,
                          _createVNode("span", _hoisted_25, _toDisplayString(item.photoList.length) + " шт.", 1)
                        ], 8, ["onClick"])
                      ])
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
})